import { T } from "../app/tokens.js";
import { PaneHeading } from "./PaneHeading.jsx";
import { ProvenanceBadge } from "../features/leases/components/ProvenanceBadge.jsx";

export function RecordFactsCard({ title, prefix, asOf, actions, children }) {
  return <section data-testid={`${prefix}-pane`} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: "12px 14px", minWidth: 0 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
      <PaneHeading style={{ marginBottom: 0, flex: 1, minWidth: 0 }}>{title}</PaneHeading>
      <span data-testid={`${prefix}-as-of`} style={{ fontSize: T.fsXxs, color: T.mid, whiteSpace: "nowrap" }}>As of {asOf}</span>
      {actions}
    </div>
    {children}
  </section>;
}

export function RecordFactsGrid({ prefix, children }) {
  return <div data-testid={`${prefix}-grid`} style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 8 }}>{children}</div>;
}

export function RecordFactTile({ prefix = "key-terms", testId, title, value, sub, source, tooltip, children, span = 1, onClick, linkTestId }) {
  const known = value != null && value !== "";
  const Tag = onClick ? "button" : "div";
  return <Tag type={onClick ? "button" : undefined} onClick={onClick} data-testid={linkTestId || `${prefix}-tile-${testId}`}
    style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, padding: "7px 10px", minWidth: 0, gridColumn: `span ${span}`, textAlign: "left", font: "inherit", cursor: onClick ? "pointer" : undefined }}>
    <div style={{ fontSize: T.fsXxxs5 ?? T.fsXxs, fontWeight: T.fwBold, color: T.mid, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4, overflow: "hidden", textOverflow: "ellipsis" }}>{title}</div>
    {children ?? <div style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 0 }}>
      <span title={tooltip || (typeof value === "string" ? value : undefined)} style={{ fontSize: T.fsMd, fontWeight: T.fwDisplay, color: known ? (onClick ? T.blue : T.dark) : T.light, lineHeight: 1.1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minWidth: 0 }}>{known ? value : "—"}</span>
      {known && source && <ProvenanceBadge source={source} />}
    </div>}
    {sub && <div style={{ fontSize: T.fsXxxs ?? T.fsXxs, color: T.light, lineHeight: 1.3, marginTop: 2, overflowWrap: "anywhere" }}>{sub}</div>}
  </Tag>;
}
